export const ALL_VISITORS = -1;
export const EXEMPTION_MODE_VISITORS_CAP = 10;
export const DEFAULT_SEGMENTS_IDS = {
    ALL_VISITORS: -1,
    NEW_VISITORS: 1,
    RETURNING_VISITORS: 2,
    BOTS_AND_SPIDERS: 3,
    PURCHASE_INTENT_USERS: 4,
    VISITS_WITH_TRANSACTIONS: 7,
    VISITS_WITHOUT_TRANSACTIONS: 8,
    NON_BOUNCE_VISITS: 12,
    BOUNCE_VISITS: 13,
};
export class SegmentModel {
}
export const defaultSegments = (isSDK) => {
    const allVisitorsSegment = {
        id: DEFAULT_SEGMENTS_IDS.ALL_VISITORS,
        name: 'SEGMENT.ALL_VISITORS',
        category: 'visit',
        creatorId: 0,
        fovCondition: '',
        isBookmarked: false,
        projectId: null,
        updaterId: 0,
        updatedAt: new Date(),
        isDefault: true,
        deletedAt: null,
    };
    const newVisitorsSegment = {
        id: DEFAULT_SEGMENTS_IDS.NEW_VISITORS,
        name: isSDK ? 'New sessions' : 'New visitors',
        isBookmarked: false,
        category: 'visit',
        creatorId: 0,
        fovCondition: '{"nodeType":"AND","children":[{"nodeType":"OR","children":[{"field":"visit:isNew","operator":"equals","value":"true","nodeType":"filter"}]}]}',
        projectId: null,
        updaterId: 0,
        updatedAt: null,
        isDefault: true,
        deletedAt: null,
    };
    const returningVisitorsSegment = {
        id: DEFAULT_SEGMENTS_IDS.RETURNING_VISITORS,
        name: isSDK ? 'Returning users' : 'Returning visitors',
        isBookmarked: false,
        category: 'visit',
        creatorId: 0,
        fovCondition: '{"nodeType":"AND","children":[{"nodeType":"OR","children":[{"field":"visit:isNew","operator":"equals","value":"false","nodeType":"filter"}]}]}',
        projectId: null,
        updaterId: 0,
        updatedAt: null,
        isDefault: true,
        deletedAt: null,
    };
    const visitsWithTransactionsSegment = {
        id: DEFAULT_SEGMENTS_IDS.VISITS_WITH_TRANSACTIONS,
        name: isSDK ? 'Sessions with transactions' : 'Visits with transactions',
        isBookmarked: false,
        category: 'visit',
        creatorId: 0,
        fovCondition: '{"nodeType":"AND","children":[{"nodeType":"OR","children":[{"nodeType":"AND","children":[{"field":"visit:isBuyer","operator":"equals","value":1,"nodeType":"filter"}]}]}]}',
        projectId: null,
        updaterId: 0,
        updatedAt: null,
        isDefault: true,
        deletedAt: null,
    };
    const visitsWithoutTransactionsSegment = {
        id: DEFAULT_SEGMENTS_IDS.VISITS_WITHOUT_TRANSACTIONS,
        name: isSDK ? 'Sessions without transactions' : 'Visits without transactions',
        isBookmarked: false,
        category: 'visit',
        creatorId: 0,
        fovCondition: '{"nodeType":"AND","children":[{"nodeType":"OR","children":[{"nodeType":"AND","children":[{"field":"visit:isBuyer","operator":"equals","value":0,"nodeType":"filter"}]}]}]}',
        projectId: null,
        updaterId: 0,
        updatedAt: null,
        isDefault: true,
        deletedAt: null,
    };
    const nonBounceVisitsSegment = {
        id: DEFAULT_SEGMENTS_IDS.NON_BOUNCE_VISITS,
        name: isSDK ? 'Non-bounce sessions' : 'Non-bounce visits',
        isBookmarked: false,
        category: 'visit',
        creatorId: 0,
        fovCondition: '{"nodeType":"AND","children":[{"nodeType":"OR","children":[{"field":"visit:pageviews","operator":">","value":1,"nodeType":"filter"}]}]}',
        projectId: null,
        updaterId: 0,
        updatedAt: null,
        isDefault: true,
        deletedAt: null,
    };
    const bounceVisitsSegment = {
        id: DEFAULT_SEGMENTS_IDS.BOUNCE_VISITS,
        name: isSDK ? 'Bounce sessions' : 'Bounce visits',
        isBookmarked: false,
        category: 'visit',
        creatorId: 0,
        fovCondition: '{"nodeType":"AND","children":[{"nodeType":"OR","children":[{"field":"visit:pageviews","operator":"equals","value":1,"nodeType":"filter"}]}]}',
        projectId: null,
        updaterId: 0,
        updatedAt: null,
        isDefault: true,
        deletedAt: null,
    };
    const purchaseIntentUsersSegment = {
        id: DEFAULT_SEGMENTS_IDS.PURCHASE_INTENT_USERS,
        name: 'High Intent Users',
        isBookmarked: false,
        category: 'visit',
        creatorId: 0,
        fovCondition: '{"nodeType":"AND","children":[{"nodeType":"filter","field":"visit:purchaseIntent","operator":"equals","value":true}]}',
        projectId: null,
        updaterId: 0,
        updatedAt: null,
        isDefault: true,
        deletedAt: null,
    };
    const botsAndSpidersSegment = {
        id: DEFAULT_SEGMENTS_IDS.BOTS_AND_SPIDERS,
        name: 'Bots and spiders',
        isBookmarked: false,
        category: 'visit',
        creatorId: 0,
        fovCondition: '{"children": [{"field": "visit:isBot", "value": true, "nodeType": "filter", "operator": "equals"}], "nodeType": "AND"}',
        projectId: null,
        updaterId: 0,
        updatedAt: null,
        isDefault: true,
        deletedAt: null,
    };
    return [
        allVisitorsSegment,
        newVisitorsSegment,
        returningVisitorsSegment,
        visitsWithTransactionsSegment,
        visitsWithoutTransactionsSegment,
        nonBounceVisitsSegment,
        bounceVisitsSegment,
        purchaseIntentUsersSegment,
        botsAndSpidersSegment,
    ];
};
//# sourceMappingURL=segment.js.map